// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { brokeredPreviewStorage } from './previewAuthStorage';
// OUTAGE-1 — see authLock.ts. Without this the SDK's own lock waits
// forever for `lock:sb-<ref>-auth-token`, so one dead tab freezes
// getSession() in every other tab and the whole app shell with it.
// THIS FILE IS GENERATED: if auth ever hangs like that again, the
// first thing to check is that the `lock` option below is still here.
import { boundedAuthLock } from './authLock';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: brokeredPreviewStorage(),
    persistSession: true,
    autoRefreshToken: true,
    lock: boundedAuthLock,
  }
});